import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { NOTIFY } from "../../based/Constants";
import { ConfirmDialog } from "../../based/Dialog";
import { Notify } from "../../based/Notify";
import ArtistServices from "../../based/services/ArtistServices";
import liveStreamIcon from "../components/Image/live.svg";
import ModalAddStream from "../components/ModalAddStream";

export const liveModel = {
  id: 0,
  title: "",
  isActive: true,
  url: "",
  isDelete: false,
  createdBy: "",
  createdDate: new Date(),
};

function StreamDesktop() {
  const [isModal, setIsModal] = useState(false);
  const [data, setData] = useState([]);
  const [liveStream, setLiveStream] = useState(liveModel);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    getLiveStream();
  }, []);

  const getLiveStream = async () => {
    setLoading(true);
    let [err, data] = await ArtistServices.GetLiveStreamByUser();
    if (!err && data && data.length > 0) {
      setData(data);
      setLoading(false);
    } else {
      setData([]);
      setLoading(false);
    }
  };

  const isValidElement = (link)=>{
    if(link.startsWith("https://tiktok.com/") || link.startsWith("https://vt.tiktok.com/") || link.startsWith("https://fb.gg"))
      return true;
    return false;
  }

  const createLinkLive = async () => {
    if (!liveStream.url) {
      setErrorMessage("Vui lòng nhập link live stream");
    }else if(!isValidElement(liveStream.url)){
      let msg = `Link live stream không đúng (Ví dụ: 'https://vt.tiktok.com/abc123...')`
      setErrorMessage(msg);

    } else {
      setErrorMessage("");
      setLoading(true);
      let [err, data] = await ArtistServices.CreateOrUpdateLinkStream({
        ...liveStream,
      });
      if (!err && data == 1) {
        setLoading(false);
        getLiveStream();
        Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Tạo thành công");
      } else {
        if (data == -2) {
          setLoading(false);
          Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Đã tồn tại");
        } else {
          setLoading(false);
          Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Tạo thất bại");
        }
      }
    }
  };
  const stopLive = async (id) => {
    const ids = [];
    ids.push(id);
    ConfirmDialog("Xác nhận dừng?", "Bạn có chắc chắn muốn dừng live?", () => {
      return new Promise(async (resolve, reject) => {
        setLoading(true);
        let [err, data] = await ArtistServices.DeleteLinkStream(ids);
        if (!err && data) {
          setLiveStream({ ...liveModel });
          getLiveStream();
          resolve({ title: "Thành công", msg: "Dừng live thành công." });
          setLoading(false);
        } else {
          setLiveStream({ ...liveModel });
          setLoading(false);
        }
      });
    });
  };

  return (
    <StreamDesktopStyle>
      <div className="title-artist">
        <h2>Livestream</h2>
        {data && data.length > 0 ? (
          <button
            onClick={() => {
              setIsModal(true);
            }}
          >
            Tạo mới
          </button>
        ) : (
          ""
        )}
      </div>
      {data && data.length > 0 ? (
        <ul className="history-list">
          {data.map((item, idx) => {
            return (
              <li key={idx} className="col">
                <StreamItem item={item} stopLive={stopLive} />
              </li>
            );
          })}
        </ul>
      ) : (
        <div className="newLive">
          <input
            type="text"
            placeholder="Sao chép liên kết link livestream dán vào đây"
            onChange={(e) => {
              setLiveStream({ ...liveStream, url: e.target.value });
            }}
          />
          {errorMessage && <span className="error">{errorMessage}</span>}
          <button
            onClick={() => {
              createLinkLive();
            }}
          >
            Bắt đầu livestream
          </button>
        </div>
      )}
      {/* <span className="desc">Lịch sử</span>
            <ul className="history-list">
                <li className="col">
                    <div className="item">
                        <div className="date">
                            <div>
                                <span>20.04.2023</span>
                                <span className="ml-18">20h00</span>
                            </div>
                            <div>
                                <span>01:25:20</span>
                            </div>
                        </div>
                        <div className="title">
                        Title Livesteam ở đây, thiết kế áo thun theo yêu cầu sale sập sàn
                        </div>
                        <div className="social">
                            <div className="item-social">
                                <img src={Facebook} alt="Facebook"/>
                            </div>
                            <div className="item-social">
                                <img src={Tiktok} alt="Tiktok"/>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="col">
                    <div className="item">
                        <div className="date">
                            <div>
                                <span>20.04.2023</span>
                                <span className="ml-18">20h00</span>
                            </div>
                            <div>
                                <span>01:25:20</span>
                            </div>
                        </div>
                        <div className="title">
                        Title Livesteam ở đây, thiết kế áo thun theo yêu cầu sale sập sàn
                        </div>
                        <div className="social">
                            <div className="item-social">
                                <img src={Facebook} alt="Facebook"/>
                            </div>
                            <div className="item-social">
                                <img src={Tiktok} alt="Tiktok"/>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="col">
                    <div className="item">
                        <div className="date">
                            <div>
                                <span>20.04.2023</span>
                                <span className="ml-18">20h00</span>
                            </div>
                            <div>
                                <span>01:25:20</span>
                            </div>
                        </div>
                        <div className="title">
                        Title Livesteam ở đây, thiết kế áo thun theo yêu cầu sale sập sàn
                        </div>
                        <div className="social">
                            <div className="item-social">
                                <img src={Facebook} alt="Facebook"/>
                            </div>
                            <div className="item-social">
                                <img src={Tiktok} alt="Tiktok"/>
                            </div>
                        </div>
                    </div>
                </li>
                <li className="col">
                    <div className="item">
                        <div className="date">
                            <div>
                                <span>20.04.2023</span>
                                <span className="ml-18">20h00</span>
                            </div>
                            <div>
                                <span>01:25:20</span>
                            </div>
                        </div>
                        <div className="title">
                        Title Livesteam ở đây, thiết kế áo thun theo yêu cầu sale sập sàn
                        </div>
                        <div className="social">
                            <div className="item-social">
                                <img src={Facebook} alt="Facebook"/>
                            </div>
                            <div className="item-social">
                                <img src={Tiktok} alt="Tiktok"/>
                            </div>
                        </div>
                    </div>
                </li>

            </ul> */}
      {isModal && (
        <ModalAddStream
          setIsModal={setIsModal}
          getLiveStream={getLiveStream}
          setLoading={setLoading}
        />
      )}
    </StreamDesktopStyle>
  );
}

function StreamItem({ item, stopLive }) {
  const [countTime, setCountTime] = useState();

  useEffect(() => {
    let now = new Date();
    let create = new Date(item.createdDate);
    let seconds = Math.floor((now.getTime() - create.getTime()) / 1000);
    setCountTime(seconds);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountTime((countTime) => countTime + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  function convertSecondsToHours(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds =
      remainingSeconds < 10 ? `0${remainingSeconds}` : `${remainingSeconds}`;

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  return (
    <div className="item">
      <div className="desc-stream">
        <img src={liveStreamIcon} />
        <span>Đang Livestream</span>
      </div>
      <div className="title">{item.url}</div>
      <div className="social">
        <div className="social-list">
          {/* <div className="item-social">
                        <img src={Tiktok} alt="Tiktok"/>
                    </div> */}
          <div className="item-social date">
            <span className="">{convertSecondsToHours(countTime)}</span>
          </div>
        </div>
        <button
          className="stop-live"
          onClick={() => {
            stopLive(item.id);
          }}
        >
          Dừng
        </button>
      </div>
    </div>
  );
}
const StreamDesktopStyle = styled.div`
  width: 100%;
  padding: 0 24px;


  .ml-18 {
    margin-left: 18px;
  }

  .newLive {
    position: relative;
    .error {
      color: red;
    }
    input {
      background: #464646;
      border-radius: 10px;
      height: 42px;
      width: 100%;
      padding: 0 20px;
      border: none;
      outline: none;
      color: white;

      ::placeholder {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: -0.3px;
        color: #ffffff;
        opacity: 0.2;
      }
    }

    button {
      background: linear-gradient(259.14deg, #06f1b9 1.32%, #008263 100%);
      border-radius: 10px;
      margin-top: 20px;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: -0.3px;
      color: #ffffff;
      display: grid;
      place-items: center;
      width: 193px;
      height: 42px;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }

  .desc {
    display: block;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: #ffffff;
    margin-left: 8px;
    margin-top: 16px;
  }

  .history-list {
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    margin: 20px -12px 0;

    .col {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      padding: 0 12px;

      .item {
        width: 100%;
        padding: 10px 16px;
        border-radius: 10px;
        background-color: #464646;
        margin-bottom: 10px;

        .stop-live {
          width: 86px;
          height: 42px;
          border: 2px solid #06f1b9;
          border-radius: 10px;
          font-weight: 600;
          font-size: 16px;
          line-height: 20px;
          letter-spacing: -0.3px;
          color: #06f1b9;
          display: grid;
          place-items: center;
          background-color: transparent;
          cursor: pointer;
        }

        .desc-stream {
          img {
            animation: scale 1s infinite ease-in-out;
          }
          span {
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            letter-spacing: -0.3px;
            color: #06f1b9;
            margin-left: 12px;
          }
        }
        @keyframes scale {
          0% {
            transform: scale(0.8);
          }
          100% {
            transform: scale(1);
          }
        }

        .date {
          display: flex;
          align-items: center;
          justify-content: space-between;

          span {
            font-weight: 500;
            font-size: 14px;
            line-height: 18px;
            letter-spacing: -0.3px;
            color: #9a9a9a;
          }
        }

        .title {
          font-weight: 500;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: -0.3px;
          color: #ffffff;
          margin-top: 5px;
          margin-bottom: 13px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 100%;
        }

        .social {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .social-list {
            display: flex;
            align-items: center;
            .item-social {
              margin-right: 6px;
            }
          }
        }
      }
    }
  }
  .title-artist {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h2 {
      font-weight: 600;
      font-size: 25px;
      line-height: 31px;
      letter-spacing: -0.3px;
      color: #ffffff;
    }
    button {
      width: 180px;
      height: 46px;
      background: linear-gradient(259.14deg, #06f1b9 1.32%, #008263 100%);
      border-radius: 10px;
      display: grid;
      place-items: center;
      font-weight: 600;
      font-size: 18px;
      line-height: 20px;
      letter-spacing: -0.3px;
      color: #ffffff;
      border: none;
      outline: none;
    }
  }

  @media (min-width: 1025px) {
    .history-list {
      .col {
        width: 50%;
        max-width: 50%;
        min-width: 50%;
      }
    }
  }
`;
export default StreamDesktop;



// WEBPACK FOOTER //
// ./src/artist-ui/Stream/StreamDesktop.js